import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Once initialized in `}<inlineCode parentName="p">{`instrumentation-client.js|ts`}</inlineCode>{`, import `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` from `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` anywhere and call the methods you need on the `}<inlineCode parentName="p">{`posthog`}</inlineCode>{` object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`'use client'
import posthog from 'posthog-js'

export default function Home() {
  return (
    <div>
      <button onClick={() => posthog.capture('test_event')}>
        Click me for an event
      </button>
    </div>
  );
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      